import React from 'react';
import _ from 'lodash';

import ModelContextEditor from './ModelContextEditor';

export default function ModelIdSelector({ value, onChange, makes = false, multi = false, className = '', ...props }) {
  let groupsToUse = ['models', 'families', 'submodels'];
  if (makes) {
    groupsToUse.push('makes');
  }

  if (multi) {
    return <div className={`zoom-90 ${className}`} style={{ minWidth: '300px' }} {...props}>
      <ModelContextEditor value={(value || []).map(v => ['modelId', v])}
        onChange={vs => onChange(_.uniq((vs || []).map(v => v[1])))}
        contextObject={false}
        groupsToUse={groupsToUse}
        {...props} />
    </div>
  } else {
    return <span className={`zoom-90 ${className}`} style={{ minWidth: '300px' }} {...props}>
      <ModelContextEditor value={value ? { modelId: value } : null}
        onChange={ctx => onChange(ctx?.modelId)}
        groupsToUse={groupsToUse}
        {...props} />
    </span>
  }
}
